import { Icon, Indicator, Link, Typography } from '@globalmed/atlas-ui';
import { useNotificationInfo } from '../../hooks/useNotificationInfo';
import style from './NotificationItem.module.css';
import { TNotificationAppointmentsCamel } from '@/types';
import { formatSessionDate } from '@/utils/convertDate';

type TProps = {
  notification: TNotificationAppointmentsCamel;
  onClose: () => void;
};
// notification.meta.status - use for reschedule.
export const NotificationItem = (props: TProps) => {
  const {
    isFormerProvider,
    isReadNotification,
    notificationInfo,
    timeAgo,
    rescheduledStartDates,
  } = useNotificationInfo(props);

  return (
    <div className={style.item}>
      <div className={style.wrapper}>
        <Typography
          as="h2"
          fontSize="16px"
          sx={{ lineHeight: '24px', fontWeight: '600' }}
        >
          {notificationInfo.description}
        </Typography>
        {!isReadNotification && <Indicator value="point" />}
      </div>
      <Typography
        mb="12px"
        color={'var(--colors-gray600)'}
        sx={{ lineHeight: '20px', fontWeight: '400' }}
      >
        {timeAgo}
      </Typography>
      {!!rescheduledStartDates && (
        <div className={style.date}>
          <Typography
            mb="4px"
            color={'var(--colors-gray600)'}
            sx={{
              lineHeight: '20px',
              fontWeight: '400',
              display: 'flex',
              alignItems: 'center',
              columnGap: '4px',
            }}
          >
            <span style={{ textDecorationLine: 'line-through' }}>
              {formatSessionDate(rescheduledStartDates.oldStart)}
            </span>
            <Icon name="ArrowNarrowRight" />
            {formatSessionDate(rescheduledStartDates.newStart)}
          </Typography>
        </div>
      )}
      {!isFormerProvider && (
        <div style={{ marginLeft: '4px' }}>
          <Link
            text={notificationInfo.button.text}
            color="grey"
            size="sm"
            weight="semibold"
            onClick={notificationInfo.button.onClick}
          />
        </div>
      )}
    </div>
  );
};
